export const encuestasLang = {
    "titulo": {
        "es": "Encuestas",
        "en": "Surveys"
    },

}